import { DataSetImportDataDialog } from "#batteries-included-components/Dialogs/DataSetImportDataDialog";
import { useLocation, useSearchParams } from "#src/Routers/hooks";
import { ImportDataActionStatusWithQueue } from "#src/batteries-included-components/Banners/ImportDataActionStatus";
import { getDataSetImportDataActionQueueKey } from "#src/batteries-included-components/Dialogs/DataSetImportDataDialog/DataSetImportDataDialog.helpers";
import { useIsFeatureAvailable } from "#src/contexts/AuthenticatedContext.helpers";
import { ConfigurationTemplateRunsListTab } from "#src/routes/data-tools/submissions/configuration-templates/ConfigurationTemplateRunsListTab";
import { DataSetSubmissionsListTab } from "#src/routes/data-tools/submissions/datasets/DataSetSubmissionsListTab";
import { useBreadcrumbsFromRoute } from "#src/utils/route";
import { Button, Icon, Page, Tab } from "@validereinc/common-components";
import React, { useState } from "react";
import { DataSubmissionsRoutePath } from ".";
import { ConfigurationTemplateSubmissionsRoutePath } from "./configuration-templates";
import { DataSetSubmissionsListRoutePath } from "./datasets";

export const DataSubmissionsListPageTabs = {
  DataSetsTab: "datasets",
  ConfigurationsTab: "configuration-templates",
} as const;

export const DataSubmissionsListPage = () => {
  const [searchParams, setSearchParams] =
    useSearchParams<
      Exclude<typeof DataSubmissionsRoutePath.queryParams, undefined>
    >();
  const location = useLocation();
  const [breadcrumbs] = useBreadcrumbsFromRoute(DataSubmissionsRoutePath);
  const [isConfigurationTemplatesAvailable] = useIsFeatureAvailable({
    featureFlagQuery: "core:templated_configurations",
    permissionQuery: "templated_configuration_runs:read",
  });
  const [isImportDialogOpen, setIsImportDialogOpen] = useState(false);

  const DEFAULT_TAB_KEY =
    ConfigurationTemplateSubmissionsRoutePath.path === location.pathname
      ? DataSubmissionsListPageTabs.ConfigurationsTab
      : DataSubmissionsListPageTabs.DataSetsTab;
  const datasetImportDataActionQueueKey = getDataSetImportDataActionQueueKey();

  return (
    <Page
      title={DataSubmissionsRoutePath.title}
      breadcrumbs={breadcrumbs}
      activeTabKey={searchParams?.tab ?? DEFAULT_TAB_KEY}
      onActiveTabKeyChange={(tabKey: string) => {
        setSearchParams({ tab: tabKey });
      }}
      actionRow={[
        !searchParams.tab ||
        searchParams.tab === DataSubmissionsListPageTabs.DataSetsTab ? (
          <Button
            key="import"
            variant="primary"
            slotLeft={<Icon variant="arrow-square-in" />}
            onClick={() => setIsImportDialogOpen(true)}
          >
            Import
          </Button>
        ) : null,
      ]}
    >
      <Tab
        title={DataSetSubmissionsListRoutePath.title}
        tabKey={DataSubmissionsListPageTabs.DataSetsTab}
      >
        <ImportDataActionStatusWithQueue
          queueKey={datasetImportDataActionQueueKey}
        />
        <DataSetSubmissionsListTab />
        <DataSetImportDataDialog
          isOpen={isImportDialogOpen}
          onClose={() => setIsImportDialogOpen(false)}
        />
      </Tab>
      {isConfigurationTemplatesAvailable ? (
        <Tab
          title={ConfigurationTemplateSubmissionsRoutePath.title}
          tabKey={DataSubmissionsListPageTabs.ConfigurationsTab}
        >
          <ConfigurationTemplateRunsListTab />
        </Tab>
      ) : null}
    </Page>
  );
};
